import { useState, type JSX } from 'react';
import { SizePills } from '@/components/ui';
import { updatedImageUrl } from '@/utils/formatting';
import styles from './SizeSelectionSheet.module.css';
import type { SizeSelectionSheetProps } from './SizeSelectionSheet.types';

export const SizeSelectionSheet = ({
  availableSizes,
  selectedSize,
  paymentStatus,
  sizeChartUrl,
  onSizeSelect,
  onClose,
  onContinue,
}: SizeSelectionSheetProps): JSX.Element => {
  const [isImageLoading, setIsImageLoading] = useState<boolean>(true);
  const isProcessing =
    paymentStatus === 'creating_order' ||
    paymentStatus === 'confirming_payment';

  return (
    <>
      <div className={styles.modalBackdrop} onClick={onClose} />
      <div className={styles.bottomSheetPanel}>
        <div className={styles.dragHandleArea}>
          <div className={styles.dragHandleBar} />
        </div>

        {sizeChartUrl && (
          <div
            className={`${styles.sizeChartContainer} ${isImageLoading ? styles.loading : ''}`}
          >
            {isImageLoading && <div className={styles.imageSkeleton} />}
            <img
              src={updatedImageUrl(sizeChartUrl)}
              alt="Size Chart"
              className={styles.sizeChartImage}
              onLoad={() => setIsImageLoading(false)}
            />
          </div>
        )}

        <div className={styles.selectorFrame}>
          <div className={styles.selectSizeTitle}>SELECT SIZE</div>
          <SizePills
            availableSizes={availableSizes}
            selectedSize={selectedSize}
            className={styles.sizePillsWrapper}
            onSizeSelect={onSizeSelect}
          />
          <button
            className={styles.continueBtn}
            disabled={!selectedSize || isProcessing}
            onClick={onContinue}
          >
            {isProcessing ? 'Processing...' : 'Continue'}
          </button>
        </div>
      </div>
    </>
  );
};

export default SizeSelectionSheet;
